/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ChartBar from '../../../components/Chartjs/BarChart'
import Reports from '../../../functions/logic/Reports'
import Maintenance from '../../../functions/logic/Maintenance'
import DynamicTable from '../../../components/DataTables/DynamicTable'
import Spiner from '../../../components/Spiner'
import Select2 from '../../../components/Select2'


export default function Clients() {
    const param = useParams()
    const [spiner, setSpiner] = useState(false)
    const [dataKey, setDataKey] = useState(false)
    const [dataChart, setDataChart] = useState([])
    const [year, setYear] = useState([])
    const [yearActual, setYearActual] = useState(new Date().getFullYear().toString())
    const [yearNow, setYearNow] = useState([])
    const userToken = localStorage.getItem('userToken')
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const [monthNumber, setMonthNumber] = useState(0)
    const columns = ['Cliente', 'Identificacion', 'Email', 'Orden', 'Producto', 'Fecha']

    useEffect(() => {
        getClientChart(param)
    }, [param])

    const getClientChart = async (param) => {
        setSpiner(true)
        global.MENU_MODULE_SELECT = 'reporteria'
        const actualYear = new Date()
        const response = await Reports.clientDataLogic(userToken, param.moduleId, actualYear.getFullYear())
        const yearsResp = Maintenance.getYears()
        setYear(yearsResp)
        localStorage.setItem('param', JSON.stringify(param.moduleId))
        setDataChart(response)
        setDataKey('Clientes')
        setSpiner(false)
        setYearNow(actualYear.getFullYear())
    }

    const handledClick = async (event) => {
        const monthNumber = event["activePayload"]?.[0]?.["payload"]?.["monthnumber"]
        
        if (!monthNumber) {
            setSpiner(false)
            return
        }
    
        setSpiner(true)
        setMonthNumber(monthNumber)
        
        try {
            const response = await Reports.clientDataByMonthLogic(1, 5, 'no', userToken, param.moduleId, monthNumber, yearNow)
            
            if (response && response.responseTableMapper && response.responseTableMapper.length > 0) {
                setdata(response.responseTableMapper)
                setTotalRows(response.total_records)
            } else {
                setdata([])
                setTotalRows(0)
            }
        } catch (error) {
            console.error("Error al obtener los datos:", error)
        } finally {
            setSpiner(false)
        }
    }
    

    const handlePageChange = async (page, perPage) => {
        setSpiner(true)
        const response = await Reports.clientDataByMonthLogic(page, perPage, 'no', userToken, param.moduleId, monthNumber, yearNow)
        setdata(response["responseTableMapper"])
        setTotalRows(response.total_records)
        setSpiner(false)
    }

    const handleOnChange = async (event) => {
        setSpiner(true)
        setYearActual(event.target.value)
        setYearNow(event.target.value)
    
        setdata([])
        
        const response = await Reports.clientDataLogic(userToken, param.moduleId, event.target.value)
        if (response && response.length > 0) {
            setDataChart(response)
        } else {
            setDataChart([])
        }
    
        setSpiner(false)
    }

    const handleSearch = async (item) => {
        setSpiner(true)
    
        setdata([])
        
        let response
        if (item === "") {
            response = await Reports.clientDataByMonthLogic(1, 5, 'no', userToken, param.moduleId, monthNumber, yearNow)
        } else {
            response = await Reports.clientDataByMonthLogic(1, 1, item, userToken, param.moduleId, monthNumber, yearNow)
        }
        
        if (response && response.responseTableMapper && response.responseTableMapper.length > 0) {
            setdata(response.responseTableMapper)
            setTotalRows(response.total_records)
        } else {
            setdata([])
            setTotalRows(0)
        }
    
        setSpiner(false)
    }

    return (
        <>
            <Spiner opt={spiner} />
            <div className="content-wrapper">
                <section className="content-header">
                    <Select2
                        year={yearActual} 
                        data={year}
                        col={'col-md-2'}
                        header={""}
                        TextInit={"Seleccione un año"}
                        handledOnChange={handleOnChange}
                    />
                </section>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Reporte clientes por mes ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <ChartBar handledClick={handledClick} dataChart={dataChart} dataKey={dataKey} />
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">
                                            Clientes por mes ({yearNow})</h3>
                                    </div>
                                    <div className="card-body">
                                        <div className="col-md-12">
                                            <DynamicTable
                                                columns={columns}
                                                data={data}
                                                headerText=""
                                                onSearch={handleSearch}
                                                onPageChange={handlePageChange}
                                                totalRows={totalRows}
                                            />
                                        </div>
                                    </div>
                                </div >
                            </div >
                        </div >
                    </div >
                </section >
            </div >
        </>
    )

}






